<template>
    <div class="page-sign-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">客服專區</div>
            <div class="breadcrumb-item">APP充值記錄</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()" placeholder="輸入手機號碼"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table ref="table"
                   size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleClick(index)">核查</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        <Modal v-model="isShowModalClick"
               title="核查"
               width="400"
               :footer-hide="true"
               @on-cancel="handleModalCloseClick">
            <div class="modal-cont">
                <Spin fix class="pg-sub-loading" v-if="isSubmitingClick">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>
                <Form>
                    <label class="input-label" style="color:black;width:100%;">訂單號：{{form_transer.num_order}}</label>
                    <br>
                    <br>
                    <label class="input-label" style="color:black;width:100%;">{{form_transer.msg}}</label>
                    <br>
                    <br>
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn" style="width:100%;color: red;" @click="handleModalCloseClick">確定</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'

    let isthis;
    export default {
        data()
        {
            return {
                detail: [],
                pickAddress: [],

                isShowModalClick: false,
                isSubmitingClick: false,

                isSubmiting: false,
                isShowModalSign_goods: false,
                isSubmitingLog: false,

                pageIndex: 1, //頁碼
                curPageSize: 10, //一頁數量
                totalCount: 1, //總條數
                pageInput: '', //輸入的頁碼
                form: {
                    phone: '', //電話號碼
                },
                form_transer: {
                    num_order: '',
                    msg: ''
                },
                activity:'',
                outtimepay:'',
                pay_type: '',
                sums: 0,
                table: {
                    column: [
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 50
                        },
                        {
                            title: '訂單號',
                            key: 'num_order',
                            align: 'center',
                            minWidth: 180,
                            sortable: true
                        },
                        {
                            title: '客戶電話',
                            key: 'phone',
                            align: 'center',
                            minWidth: 130,
                            sortable: true
                        },
                        {
                            title: '支付方式',
                            key: 'paytype',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '充值金額',
                            key: 'amount',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '狀態(同步)',
                            key: 'paystatus',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '狀態(異步)',
                            key: 'paystatusnoti',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '創建時間',
                            key: 'created_time',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '完成時間',
                            key: 'notitime',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                    ],
                    data: []
                },
                table1: {
                    column: [
                        {
                            title: '快遞單號',
                            key: 'order',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶電話',
                            key: 'phone',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶名稱',
                            key: 'username',
                            align: 'center',
                            minWidth: 80
                        },
                    ],
                    column1: [
                        {
                            title: '重量',
                            key: 'weight',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '尺寸',
                            key: 'size_sum',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '提貨櫃點',
                            key: 'store',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column2: [
                        {
                            title: '快件明細',
                            key: 'detailed',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '異常件',
                            key: 'abnormal',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '出庫袋號',
                            key: 'sack_number',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column3: [
                        {
                            title: '最新貨態',
                            slot: 'status',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '更新時間',
                            key: 'created_time',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '貨架號',
                            key: 'shelves',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column4: [
                        {
                            title: '代收費',
                            key: 'amount',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '附加費',
                            key: 'surcharge_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '到附運費',
                            key: 'freight_collect',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column5: [
                        {
                            title: '超期費',
                            key: 'outTime_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '合計費用',
                            key: 'total_price',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    data: [],
                    data1: [],
                    data2: [],
                    data3: [],
                    data4: [],
                    data5: [],
                },
                curCheckedList: [], //当前选中的数据
            };
        },
        created() {
            isthis = this;
        },
        mounted()
        {
            this.getList();
        },
        methods: {

            getDateTime(datetime)
            {
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum_log(year)}-${this.formateNum_log(month)}-${this.formateNum_log(day)}`,
                    time: `${this.formateNum_log(hour)}:${this.formateNum_log(minute)}:${this.formateNum_log(second)}`,
                    week: weekList[week]
                };
            },

            formatDate(datetime){
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },

            formatNum(num){
                return num < 10 ? '0' + num : num;
            },

            formateNum_log(num){
                return num > 9 ? num : '0' + num;
            },

            getList(){
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.customer_integral_record,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        phone: form.phone,
                    }
                }).then((res) =>
                {
                    console.log(res);
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            if(resData[i].paytype == 1){
                                resData[i].paytype = '中銀APP';
                            }
                            if(resData[i].paytype == 2){
                                resData[i].paytype = '中銀微信';
                            }
                            if(resData[i].paytype == 3){
                                resData[i].paytype = '支付寶';
                            }
                            if(resData[i].paytype == 4){
                                resData[i].paytype = '積分';
                            }
                            if(resData[i].paytype == 5){
                                resData[i].paytype = 'Mpay';
                            }
                            if(resData[i].paytype == 6){
                                resData[i].paytype = 'ICBC';
                            }

                            //支付狀態同步,S成功,F預創建,T退款,C取消訂單
                            if(resData[i].paystatus == "S"){
                                resData[i].paystatus = '成功';
                            }
                            if(resData[i].paystatus == "F"){
                                resData[i].paystatus = '預創建';
                            }
                            if(resData[i].paystatus == "T"){
                                resData[i].paystatus = '退款';
                            }
                            if(resData[i].paystatus == "C"){
                                resData[i].paystatus = '取消訂單';
                            }

                            //支付狀態同步,S成功,F預創建,T退款,C取消訂單
                            if(resData[i].paystatusnoti == "S"){
                                resData[i].paystatusnoti = '成功';
                            }
                            if(resData[i].paystatusnoti == "F"){
                                resData[i].paystatusnoti = '預創建';
                            }
                            if(resData[i].paystatusnoti == "T"){
                                resData[i].paystatusnoti = '退款';
                            }
                            if(resData[i].paystatusnoti == "C"){
                                resData[i].paystatusnoti = '取消訂單';
                            }

                            tempArr.push({
                                
                                num_order: resData[i].num_order,

                                amount: resData[i].amount,

                                phone: resData[i].phone,

                                paystatus: resData[i].paystatus,

                                paystatusnoti: resData[i].paystatusnoti,

                                paytype: resData[i].paytype,

                                store: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName,

                                notitime: resData[i].notitime == null ? '- - -' : this.formatDate(resData[i].notitime),

                                created_time: this.formatDate(resData[i].created_at),

                            });
                        }
                        this.totalCount = res.data.count;

                        this.table.data = tempArr;
                    
                    } 
                    else if (res.code == 1)
                    {
                        console.log(res);
                        this.totalCount = 0;
                        this.table.data = [];
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleModalSignClose_goods(){
                this.isShowModalSign_goods = false;
            },

            handleModalCloseClick(){
                this.isShowModalClick = false;
            },

            handleClick(index){
                this.isShowModalClick = true;
                let tableData = this.table.data;
                this.form_transer.num_order = tableData[index].num_order;
                this.handleOnClickDetail();
            },

            handleOnClickDetail(){
                this.isSubmitingClick = true;
                this.$Rq.requestAuth({
                    url: this.$Api.customer_integral_record_detail,
                    method: 'get',
                    data: {
                        order_online: this.form_transer.num_order,
                    }
                }).then((res) => {
                    this.isSubmitingClick = false;
                    this.form_transer.msg = res.msg;
                }).catch((err) => {
                    this.$Utils.showTipInfo(res.msg); 
                });
            },

            handleSearch(){
                this.pageIndex = 1;
                isthis.sums = 0;
                this.getList();
            },

            handlePageSizeChange(value){
                this.pageIndex = 1;
                isthis.sums = 0;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.floor(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                isthis.sums = 0;
                this.pageInput = value;
            },

            handlePageEnter(){
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                isthis.sums = 0;
                this.getList();
            },

            handlePageChange(value){
                this.pageIndex = value;
                isthis.sums = 0;
                this.getList();
            },

            handleViewOrder(index)
            {
                this.isShowModalSign_goods = true;
                this.isSubmitingLog = true;
                let tableData = this.table.data;

                this.$Rq.requestAuth({
                    url: this.$Api.all_search,
                    method: 'get',
                    data: {
                        order: tableData[index].odd_numbers
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    let tempArr = [];
                    let tempArr1 = [];
                    let tempArr2 = [];
                    let tempArr3 = [];
                    let tempArr4 = [];
                    let tempArr5 = [];
                    let resData = res.data;

                    if (res.code == 0)
                    {
                        for (let i = 0; i < resData.data.length; i++)
                        {
                            tempArr.push({
                                order: resData.data[i].order,
                                username: resData.data[i].username,
                                phone: resData.data[i].phone,
                            });

                            tempArr1.push({
                                weight: resData.data[i].weight,
                                size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
                                store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
                            });

                            tempArr2.push({
                                sack_number: resData.data[i].sack_number,
                                detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
                                abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
                            });

                            tempArr3.push({
                                shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
                                status: resData.data[i].status,
                                created_time: resData.data[i].created_time,
                            });

                            tempArr4.push({
                                amount: resData.data[i].amount,
                                surcharge_price: resData.data[i].surcharge_price,
                                freight_collect: resData.data[i].freight_collect,
                            });

                            tempArr5.push({
                                outTime_price: resData.data[i].outTime_price,
                                total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
                            });
                        }
                        this.table1.data = tempArr;
                        this.table1.data1 = tempArr1;
                        this.table1.data2 = tempArr2;
                        this.table1.data3 = tempArr3;
                        this.table1.data4 = tempArr4;
                        this.table1.data5 = tempArr5;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            
                this.isSubmitingLog = true;
                this.$Rq.requestAuth({
                    url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
                    method: 'get',
                    data: {}
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (Number(res.code) == 0)
                    {
                        let resData = res.data;
                        let tempArr = [];
                        let userinfo;

                        for (let j = 0; j < resData.length; j++)
                        {
                            let datetime = this.getDateTime(resData[j].created_at);
                            
                            if(resData[j].userinfos == null){
                                if(resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)){
                                    userinfo = '用戶線上支付';
                                }else{
                                    if(resData[i].admin_name != null){
                                        userinfo = resData[i].admin_name;
                                    }else{
                                        userinfo = '智能櫃派送員';
                                    }
                                }
                            }else{
                                userinfo = resData[j].userinfos.username;
                            }

                            tempArr.push({
                                userinfos: userinfo,
                                id: resData[j].id,
                                date: datetime.date,
                                week: datetime.week,
                                time: datetime.time,
                                describe: resData[j].remarks
                            });
                        }

                        this.detail = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import 'integralrecord.scss';
</style>
<style>
    .ivu-table td.demo-table-info-column{
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table td.demo-table-info-cell-name {
        background-color: #D6E7FF;
        color: #515A6E;
    }
    .ivu-table td.demo-table-info-cell-name-sum {
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table .demo-table-error-row {
        background-color: #fcffd6;
        color: #515A6E;
    }
    .ivu-table .demo-table-info-row {
        background-color: #FFEBDE;
        color: #515A6E;
    }
    .ivu-table .demo-table-app-row {
        background-color: #e8ffd6;
        color: #515A6E;
    }
</style>